import { jsxs as b, jsx as n } from "react/jsx-runtime";
import { useDraggable as F } from "@dnd-kit/core";
import _ from "classnames";
import { FORMA_FOLDER_ID_STATIC as A, FORMA_FOLDER_ID_PACKS as I, FORMA_FOLDER_ID_STRICT as w, FORMA_FOLDER_ID_TRASH as x, FORMA_FOLDER_ID_BACK as E } from "../../../../data/constants.js";
const L = "forma-filling__drag-grid-item__wrapper", N = "forma-filling__drag-grid-item__substrate", S = "forma-filling__drag-grid-item__childsOpen", T = "forma-filling__drag-grid-item__container", y = "forma-filling__drag-grid-item__children", M = "forma-filling__drag-grid-item__menuOpen", v = "forma-filling__drag-grid-item__draggable", C = "forma-filling__drag-grid-item__updated", j = "forma-filling__drag-grid-item__show", r = {
  wrapper: L,
  substrate: N,
  childsOpen: S,
  container: T,
  children: y,
  menuOpen: M,
  draggable: v,
  updated: C,
  show: j
}, P = ({
  id: a,
  type: d,
  name: l,
  removed: o,
  folderId: g,
  isUpdated: m,
  isMenuOpen: t,
  isModalOpen: c,
  isChildsOpen: i,
  children: f
}) => {
  const p = [
    A,
    I,
    w,
    x,
    E
  ].includes(a), s = !(t || c || p || o), { attributes: O, listeners: u, setNodeRef: D, transform: e, isDragging: R } = F({
    id: a,
    data: { id: a, type: d, name: l, folderId: g },
    disabled: !s
  }), h = {
    transform: e ? `translate3d(${e.x}px, ${e.y}px, 0)` : "",
    opacity: R ? 0 : 1
  };
  return /* @__PURE__ */ b("div", { className: r.wrapper, children: [
    /* @__PURE__ */ n("div", { className: _(r.substrate, i && r.childsOpen) }),
    /* @__PURE__ */ n(
      "div",
      {
        className: _(
          r.children,
          s && r.draggable,
          m && r.updated,
          t && r.menuOpen,
          i && r.childsOpen
        ),
        style: h,
        ...u,
        ...O,
        ref: D,
        children: f
      }
    )
  ] });
};
export {
  P as default
};
